import 'core-js/stable'
import 'custom-event-polyfill'
import 'regenerator-runtime/runtime'
import '@/lib/mutation-observer-polyfill.ts'
import '@/css/index.scss'
import '@/keep-icon.font'
// above imports should be load first
/**
 * Entry logic file
 * @see /vue.config.js pages>index>entry
 */
import debugMessage from '@/lib/debug-message'
import {bootInfoLoader} from '@/bootInfoLoader'
import Vue from 'vue'
import bootstrap from '@/bootstrap'
import {Component} from 'vue-property-decorator'

import {initVuexFilters} from '@/lib/init-vuex-filters'

// TODO: remove
// vuex-storage -> vuex-filters 오류로 인해 clear 해줌.
// vuex-storage 오류가 픽스 되거나, vuex-storage 대체 한 후 삭제할 예정
initVuexFilters()

/**
 * Resister component hooks
 */
Component.registerHooks([
  // vue-meta
  'meta',
  // vue-router
  'beforeRouteLeave',
  'beforeRouteEnter',
  'beforeRouteUpdate',
])

const env: any = process.env.ENV

/**
 * Prohibit to run bootstrap in running with test env for test
 */
if(process.env.NODE_ENV !== 'test') {
  bootstrap(Vue, bootInfoLoader(), {env})
    .catch((error) => {
      debugMessage(error)
    })
}

